import { Component } from '@angular/core';
import { HrBaseElementComponent } from '../hr-base-element/hr-base-element.component';

@Component({
    selector: 'hr-form-checkbox',
    templateUrl: './hr-form-checkbox.component.html',
})
export class HrFormCheckboxComponent extends HrBaseElementComponent {}
